// Original liquor photographs. The certificate (banner22) is intentionally excluded.
export const productPhotos = [
  { src: "/m-banner11.jpg", alt: "箱入りウイスキーを取り揃えた商品棚" },
  { src: "/m-banner33.jpg", alt: "ウイスキーのボトルと化粧箱が並ぶ商品棚" },
  { src: "/m-banner44.jpg", alt: "多様な酒類と箱入り商品のラインナップ" },
  { src: "/m-banner55.jpg", alt: "ワインボトルが並ぶ商品棚" },
  { src: "/m-banner66.jpg", alt: "ウイスキーの取扱商品の一例" },
  { src: "/m-banner77.jpg", alt: "銘柄ごとに並ぶウイスキーの商品群" },
];
